// GLOBAL DEFAULT STATE
const DEFAULT_STATE = 'display:none;';
export const getTooltipPosition = (setArrowPos) => {
    /**
     * UPPER
     */
    if (setArrowPos === 'upperLeft') {
        return `
      left: 0;
      bottom: calc(100% + 20px);
      `;
    }
    if (setArrowPos === 'upperCenter') {
        return `
    left: calc(50% - 162px);
    bottom: calc(100% + 20px);
    `;
    }
    if (setArrowPos === 'upperRight') {
        return `
      right: 0;
      bottom: calc(100% + 20px);
      `;
    }
    /**
     * LOWER
     */
    if (setArrowPos === 'lowerCenter') {
        return `
    left: calc(50% - 160px);
    top: calc(100% + 20px);
    `;
    }
    if (setArrowPos === 'lowerLeft') {
        return `
    top: calc(100% + 20px);
    left: 0;
    `;
    }
    if (setArrowPos === 'lowerRight') {
        return `
    top: calc(100% + 20px);
    right: 0;
    `;
    }
    /**
     * LEFT
     */
    if (setArrowPos === 'leftTop') {
        return `
    left: calc(-100% + 20px);
    top: 0;
    `;
    }
    if (setArrowPos === 'leftCenter') {
        return `
    left: calc(-100% + 25px);
    top: calc(50% - 50px);
    `;
    }
    if (setArrowPos === 'leftBottom') {
        return `
    left: calc(-100% + 20px);
    bottom: 0;
    `;
    }
    /**
     * Rigth
     */
    if (setArrowPos === 'rightCenter') {
        return `
    left: calc(100% + 20px);
    top: calc(50% - 50px);
    `;
    }
    if (setArrowPos === 'rightTop') {
        return `
    left: calc(100% + 20px);
    top: 0;
    `;
    }
    if (setArrowPos === 'rightBottom') {
        return `
    right: calc(-100% + 20px);
    bottom: 0;
    `;
    }
    return DEFAULT_STATE;
};
// arrow position controller
export const getArrowPosition = (setArrowPos) => {
    /**
     * UPPER
     */
    if (setArrowPos === 'upperRight') {
        return `
    right: 10px;
    bottom: -25px
    transform:rotate(-90deg);
    `;
    }
    if (setArrowPos === 'upperCenter') {
        return `
    left: calc(50% - 12px);
    bottom: -25px;
    transform: rotate(-90deg);
    `;
    }
    if (setArrowPos === 'upperLeft') {
        return `
    left: 10px;
    bottom: -25px;
    transform: rotate(-90deg);
    `;
    }
    /**
     * LOWER
     */
    if (setArrowPos === 'lowerCenter') {
        return `
    left: calc(50% - 12px);
    top: -25px;
    transform: rotate(90deg);
    `;
    }
    if (setArrowPos === 'lowerLeft') {
        return `
    left: 10px;
    top: -25px;
    transform: rotate(90deg);
    `;
    }
    if (setArrowPos === 'lowerRight') {
        return `
    right: 10px;
    top: -25px;
    transform: rotate(90deg);
    `;
    }
    /**
     * LEFT
     */
    if (setArrowPos === 'leftTop') {
        return `
    right: -25px;
    top: 6px;
    transform: rotate(180deg);
    `;
    }
    if (setArrowPos === 'leftCenter') {
        return `
    right: -25px;
    top: calc(50% - 20px);
    transform: rotate(180deg);
    `;
    }
    if (setArrowPos === 'leftBottom') {
        return `
    right: -25px;
    top: calc(100% - 32px);
    transform: rotate(180deg);
    `;
    }
    /**
     * Rigth
     */
    if (setArrowPos === 'rightCenter') {
        return `
    left: -25px;
    top: calc(50% - 20px);
    `;
    }
    if (setArrowPos === 'rightBottom') {
        return `
    bottom: 6px;
    left: -25px;
    `;
    }
    if (setArrowPos === 'rightTop') {
        return `
    left: -25px;
    top: 6px;
    `;
    }
    return DEFAULT_STATE;
};
